// @flow

import React from 'react';
import { eventTypeIcon } from '../../../const';
import type { Event } from '../../../types/shoppingCenterType';

type Props = {
  events: { [date: number]: Event[] },
  selectedKeyYear: Event,
  setSelectedKeyYear: (Event) => void,
}

function KeyYears(props: Props) {
  return (
    <div className="key-year-container">
      <div className="key-years">
        {
          Object.keys(props.events)
            .sort((b, a) => Number(b) - Number(a))
            .map(year => (
              <div key={year} className="key-year-content">
                <hr />
                <div className="key-year">
                  <div className="key-year-image-container">
                    {
                      props.events[Number(year)].map((keyYear: Event) => (
                        <button
                          key={`${keyYear.startDate}${keyYear.typeLabel}${keyYear.comments}`}
                          onClick={() => props.setSelectedKeyYear(keyYear)}
                          className={`key-year-image ${props.selectedKeyYear === keyYear ? 'selected' : ''}`}
                        >
                          <img
                            src={eventTypeIcon[keyYear.typeLabel]}
                            alt={keyYear.typeLabel}
                          />
                        </button>

                      ))
                    }
                  </div>
                  <div className="key-year-value">{year}</div>
                </div>
                <hr />
              </div>
              ))
        }
      </div>
      <div
        className="key-year-comment"
      >
        {props.selectedKeyYear && `${props.selectedKeyYear.startDate}: ${props.selectedKeyYear.comments}`}
      </div>
    </div>
  );
}

export default KeyYears;
